module.exports = __webpack_public_path__ + "img/banner3.d137b12e.png";